import { privateRequest, type ApiResponse } from "../axios"

const ENDPOINTS = {
    ATTENDANCE_COVERAGE_REPORT_DETAILS: "api/Attendance-Report-Details",
    ATTENDANCE_REPORT_EXPORT: "api/Export-Attendance",
    ATTENDANCE_SUMMARY: "api/Attendance-Summary-ByUser",
    ATTENDANCE_SUMMARY_EXPORT: "api/Export-Attendance-Summary"    
}

export const getAttendanceCoverageDetails = async (payload: any): Promise<ApiResponse<any[]>> => {
    const response = await privateRequest.get<ApiResponse<any[]>>(ENDPOINTS.ATTENDANCE_COVERAGE_REPORT_DETAILS, { params: payload });
    return response.data;
};

export const getAttendanceCoverageExport = async (payload: any): Promise<any> => {
    const response = await privateRequest.post<ApiResponse<any[]>>(ENDPOINTS.ATTENDANCE_REPORT_EXPORT, payload, { responseType: "arraybuffer" });
    return response;
};

export const getAttendanceSummary = async (payload: any): Promise<ApiResponse<any[]>> => {
    const response = await privateRequest.post<ApiResponse<any[]>>(ENDPOINTS.ATTENDANCE_SUMMARY, null, { params: payload });
    return response.data;
};

export const getAttendanceSummaryExport = async (payload: any): Promise<any> => {
    const response = await privateRequest.post<ApiResponse<any[]>>(ENDPOINTS.ATTENDANCE_SUMMARY_EXPORT, null, { params: payload, responseType: "arraybuffer" });
    return response;
};

const AttendanceCoverageReport = {
    getAttendanceCoverageDetails,
    getAttendanceCoverageExport,
    getAttendanceSummary,
    getAttendanceSummaryExport,    
}

export default AttendanceCoverageReport;